// extracted by mini-css-extract-plugin
export default {"modeledProductChart":"ModeledProducts_modeledProductChart__6BJ9s","modeledProductChartTitle":"ModeledProducts_modeledProductChartTitle__a+x6s"};